// @import_dependencies_node Import libraries
import { store } from 'app_storage/redux-storage'
// @end

// @import utilities
import { Http, HttpCustomStructure } from 'app_utils/http'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
// @end

// @import types
import { BUY_ACTION, IBuyCoursesResponse, IShoppingCarItem } from 'app_types/shoppingCart/shoppingCarTypes'
import { EfipayCurrency } from 'app_types/efipay/efipayTypes';
// @end

export interface IBillingInfo {
    fullName: string;
    firstName: string;
    lastName: string;
    docNumber: string;
    docType: string;
    nature: string;
    classification: string;
    country: string;
    department: string;
    city: string;
    currency: EfipayCurrency;
    address1?: string;
    address2?: string;
    email?: string;
    phone?: string;
}

export enum PurchaseProcessType {
  PURCHASE = "purchase",
  CHECK_CONDITIONS = "check_conditions",
}

class ShoppingCartService {

  private token: string
  private storeObject: any
  private Http: any
  private screenNotification: ScreenNotificationsUtil

  constructor() {
    this.Http = Http
    this.storeObject = store
    this.screenNotification = new ScreenNotificationsUtil()
    this.token = this.storeObject.getState().auth?.user?.token
  }

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth
    this.token = (auth.user?.token) ? auth.user.token : ''
  }

  buyCourses = async (itemsToBuy: IShoppingCarItem[], billingInfo: IBillingInfo, processType: PurchaseProcessType, buyAction: BUY_ACTION, buyerId?: string | null) => {
    this.refreshAuthToken()

    let responseData: IBuyCoursesResponse

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/enrollment/buy-courses-by-shopping-cart`,
      auth_token: this.token,
      params: {itemsToBuy, billingInfo, processType, buyAction, buyerId},
    }

    responseData = await this.Http.send(queryData)

    return responseData
  }
}

export default ShoppingCartService
